import { PulseBaseProvider } from '../../base-classes';
const _sendFeedbackUri = '/api/em/feedback/v1/send';

export class FeedbackProvider extends PulseBaseProvider {
  constructor(baseUrl, authId, secret, options, logger) {
    super(baseUrl, authId, secret, options, logger);
  }

  async sendFeedback(feedback, stdParameters, verbose) {
    const queryParams = {
    	...stdParameters,
    	verbose: !!verbose
    };

    const data = JSON.stringify(feedback);

    return await super.postData(queryParams, data, _sendFeedbackUri, true, null);
  }
}
